module.exports = __webpack_public_path__ + "static/media/bottlings10.37a5f3b0.jpg";